//import Menu from 'adeliom-menu-js';
import Menu from '../menu/Menu';

const settings = {
    stickyScrollTop: true,
    closeMenuOnScroll: true
}

const menu = new Menu(settings);
menu.init();

const localSettings = {
    indicatorSelector: '[js-menu-indicator]',
    menuItemSelector: '[js-menu-first-level]',
    currentMenuItemClass: 'current-menu-item',
    currentPageAncestorClass: 'current_page_ancestor',
}

const indicator = document.querySelector(localSettings.indicatorSelector);
const menuItems = document.querySelectorAll(localSettings.menuItemSelector);

/**
 * Returns the position of an element
 * @param el
 * @returns {{top: *, left: *, center: *}}
 */
const getOffset = el => {
    const rect = el.getBoundingClientRect();
    return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY,
        center: el.offsetWidth / 2
    };
}

if (menuItems) {
    const items = [].slice.call(menuItems);
    const currentMenuItem = items.find(item => item.classList.contains(localSettings.currentMenuItemClass) || item.classList.contains(localSettings.currentPageAncestorClass));

    if (currentMenuItem) {
        indicator.style.left = getOffset(currentMenuItem).left + getOffset(currentMenuItem).center + 'px';
        setTimeout(() => {
            indicator.style.opacity = 1;
        }, 500)
    }
}
